import { OTPFormType } from 'entities/sendOTP/types';

export const useCreateOtpDefaultValues = (): OTPFormType => ({
  displayed_name: '',
  country_id: null,
  priority: undefined,
  limit_per_day: null,
  limit_per_month: null,
  retry_time: null,
  is_enabled: true,
});
